import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Admin only: star score and reliability for every staff member, in one call
export const useStaffScores = (token, refreshKey = 0) => {
  const [scores, setScores] = useState({});

  useEffect(() => {
    const auth = token || localStorage.getItem('token');
    if (!auth) return;
    axios.get(`${API}/admin/staff-scores`, { headers: { Authorization: `Bearer ${auth}` } })
      .then((res) => setScores(res.data?.scores || {}))
      .catch(() => setScores({}));
  }, [token, refreshKey]);

  return scores;
};

export default useStaffScores;
